import React, { memo, useCallback, useState } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

function WithdrawalCard({ item, userType, reload }) {
  const {
    super_username,
    master_username,
    user_id,
    withdrawal_id,
    amount,
    msg,
    status,
    date_created,
    username,
    upi,
    account_number,
    account_name,
    account_ifsc,
    account_type,
    bank_name,
    other
  } = item;

  const [actionType, setActionType] = useState(null); // "approve" | "reject"
  const [tpassword, setTpassword] = useState("");
  const [loading, setLoading] = useState(false);

  /* ===============================
     🔹 Withdrawal Slip Preview
  =============================== */

  const openUserEditor = (type) => {
    if (!item) return;
    switch (type) {
      case "super":
        window.user_id = item.super_id;
        window.openeditSuper?.();
        break;
      case "master":
        window.user_id = item.master_id;
        window.masterModalOpen?.();
        break;
      case "user":
        window.user_id = item.user_id;
        window.userModalOpen?.();
        break;
      default:
        break;
    }
  };

  /* ===============================
     🔹 Approve / Reject Logic
  =============================== */

  const handleAction = async () => {
    if (!tpassword) {
      toast.error("Please enter transaction password");
      return;
    }

    try {
      setLoading(true);

      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_id: user_id,
        withdrawal_id,
        status: actionType === "approve" ? 1 : 2, // approve | reject
        tpassword,
      };

      const res = await backend.update_withdrawal_status(data);

      if (res?.error === "False") {
        toast.success(
          actionType === "approve"
            ? "Withdrawal Approved Successfully"
            : "Withdrawal Rejected Successfully",
        );
        setActionType(null);
        reload?.();
      } else {
        toast.error(res?.message || "Failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error");
    } finally {
      setLoading(false);
      setTpassword("");
    }
  };

  return (
    <>
      <div className="menuContainer addHight text">
        {/* ---------- ROLE COLUMNS ---------- */}
        {userType === 1 && (
          <div
            onClick={() => openUserEditor("super")}
            className={`menuExchange uppercase pointer `}
          >
            <div className="user_id">{super_username}</div>
          </div>
        )}

        {(userType === 1 || userType === 2) && (
          <div
            onClick={() => openUserEditor("master")}
            className={`menuExchange uppercase pointer small `}
          >
            <div className="user_id">{master_username}</div>
          </div>
        )}

        {(userType === 1 ||
          userType === 2 ||
          userType === 3 ||
          userType === 5 ||
          userType === 6) && (
          <div
            onClick={() => openUserEditor("user")}
            className={`menuExchange uppercase pointer small `}
          >
            <div className="user_id">{username}</div>
          </div>
        )}

        {/* ID */}
        <div className="menuUsername small">{withdrawal_id}</div>

        {/* Amount */}
        <div className="menuUsername font-semibold">
          ₹ {Number(amount || 0).toLocaleString("en-IN")}
        </div>

        {/* UPI ID */}
        <div className="menuUsername small">{upi || "-"}</div>

        <div className="menuUsername small">{account_number || "-"}</div>

        <div className="menuUsername small">{account_name || "-"}</div>

        <div className="menuUsername small">{account_ifsc || "-"}</div>

        <div className="menuUsername small">{account_type || "-"}</div>

        <div className="menuUsername small">{bank_name || "-"}</div>

        {/* MSG */}
        <div
          style={{
            fontSize: 8,
          }}
          className={`menuUsername ${status == 0 ? "text-[var(--text)]" : status == 1 ? "text-[var(--primary)]" : "text-[var(--sell)]"}`}
        >
          {msg || "-"}
        </div>

        {/* Date + Time */}
        <div
          className={`menuUsername flex flex-col items-center justify-center `}
        >
          <div className="extraSmall">
            {moment(date_created).format("DD-MM-YYYY")}
          </div>
          <div className="small">{moment(date_created).format("HH:mm:ss")}</div>
        </div>

                {/* OTHERS */}
        <div
          style={{
            fontSize: 8,
          }}
          className={`menuUsername extraSmall text-[var(--text)]`}
        >
          {other || "-"}
        </div>

        {/* ================= ACTION BUTTONS ================= */}
        {status == 0 && (
          <div className="menuUsername addFlex flex gap-2">
            {/* APPROVE */}
            <button
              onClick={() => setActionType("approve")}
              className="bg-green-600 px-2 py-1 text-xs rounded-md text-white"
            >
              ACCEPT
            </button>

            {/* REJECT */}
            <button
              onClick={() => setActionType("reject")}
              className="bg-red-600 px-2 py-1 text-xs rounded-md text-white"
            >
              REJECT
            </button>
          </div>
        )}

        {/* If already processed */}
        {status != 0 && (
          <div className="menuUsername addFlex">
            <span
              className={`px-2 py-1 text-xs rounded-md text-white ${
                status == 1 ? "bg-green-600" : "bg-red-600"
              }`}
            >
              {status == 1 ? "APPROVED" : "REJECTED"}
            </span>
          </div>
        )}
      </div>

      {/* 🔥 APPROVE / REJECT PASSWORD MODAL */}
      {actionType && (
        <div className="customModalOverlay" onClick={() => setActionType(null)}>
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">
              {actionType === "approve"
                ? "✅ Approve Withdrawal"
                : "❌ Reject Withdrawal"}
            </h3>

            <input
              type="password"
              placeholder="Enter Transaction Password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setActionType(null)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                className="dropbtnNavSub white primary"
                onClick={handleAction}
                disabled={loading}
              >
                {loading
                  ? "Processing..."
                  : actionType === "approve"
                    ? "Confirm Approve"
                    : "Confirm Reject"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default memo(WithdrawalCard);
